import { render, staticRenderFns } from "./FormInputSendMessageReplyLimit.vue?vue&type=template&id=c6f70de4&scoped=true&lang=pug"
import script from "./FormInputSendMessageReplyLimit.vue?vue&type=script&lang=ts"
export * from "./FormInputSendMessageReplyLimit.vue?vue&type=script&lang=ts"
import style0 from "./FormInputSendMessageReplyLimit.vue?vue&type=style&index=0&id=c6f70de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f70de4",
  null
  
)

export default component.exports